import { Component, inject, OnInit } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
// eslint-disable-next-line boundaries/no-unknown
import en from './../../public/i18n/en.json';

import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    ButtonModule,
    ToastModule,
    ConfirmPopupModule,
  ],
  template: `
    <router-outlet></router-outlet>
    <!-- * Message -->
    <p-toast position="bottom-right" key="br"></p-toast>

    <!-- * Warn message -->
    <p-toast position="bottom-right" key="br-warn"></p-toast>

    <!-- * Error message -->
    <p-toast position="bottom-right" key="br-error"></p-toast>
    <p-confirmpopup styleClass="p-shadow-2" />
  `,
})
export class AppComponent implements OnInit {
  translate = inject(TranslateService);
  contexts = inject(ChildrenOutletContexts);

  ngOnInit() {
    this.translate.setTranslation('en', en);
    this.translate.setFallbackLang('en');
  }
}
